import { Sparkles, X } from "lucide-react";
import { CHAT } from "../../constants/testIds";

export function ExamBanner({ exam, daysLeft, onOpen, onClear }) {
  if (!exam) return null;
  return (
    <div
      data-testid={CHAT.examBanner}
      className="exam-glow rounded-xl border border-violet-500/50 bg-violet-500/10 px-4 py-2.5 flex items-center gap-3 cursor-pointer"
      onClick={onOpen}
    >
      <div className="rounded-lg bg-violet-500/20 p-1.5">
        <Sparkles className="h-3.5 w-3.5 text-violet-300" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.15em] text-violet-300/80">
          Modo Prova
        </div>
        <div className="text-sm font-medium truncate">
          {exam.title} <span className="text-muted-foreground">·</span> <span className="text-violet-300">{daysLeft} dia{daysLeft === 1 ? "" : "s"}</span>
        </div>
      </div>
      <button
        onClick={(e) => { e.stopPropagation(); onClear(); }}
        className="rounded-full p-1.5 text-muted-foreground hover:text-foreground hover:bg-background/50"
        title="Desativar modo prova"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
